const NAME = "iconEdit";

const createActionType = (actionType: string) => `${NAME}/${actionType}`;

export const OPEN_FORM_ICONEDIT = createActionType("OPEN_FORM");

export const createOpenFormIconEditAction = (id: string) => ({
    type: OPEN_FORM_ICONEDIT,
    payload: {
        id,
    },
});
